import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AvailabilityRovoConfigProviderEntrypointProps } from './AvailabilityRovoConfigProvider.entrypoint.types.tsx';

type AvailabilityRovoConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	AvailabilityRovoConfigProviderEntrypointProps,
	{} | null
>;

export const availabilityRovoConfigProviderEntrypoint: EntryPoint<
	AvailabilityRovoConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<AvailabilityRovoConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-availability-provider" */ './AvailabilityRovoConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
